import React from 'react'
import {
    Card,
    CardContent,
    CardHeader,
    CardActions,
    Grid,
    Typography,
    Table,
    TableBody,
    TableRow,
    TableCell,
    Button,
} from '@mui/material'
import DossierModalEditButton from '../../Elements/DossierModalEditButton'

export default class BlockCardDefault extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    renderContentCard(dossierData, dossier, listItems) {
        return (
            <Card
                key={dossier.id}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    cursor: 'pointer',
                    border:
                        dossier.archived === true
                            ? '1px solid rgba(0,0,0,0.3)'
                            : undefined,
                    backgroundColor: dossier.archived
                        ? 'action.disabledBackground'
                        : 'inherit',
                }}
                onClick={(event) => this.props.handleContent(event, dossier)}
            >
                <CardContent sx={{ flexGrow: 1 }}>
                    <Typography variant="h6" component="div" gutterBottom>
                        {dossier.summary}
                    </Typography>

                    <Table size="small" sx={{ mt: 1 }}>
                        <TableBody
                            sx={{
                                '& .MuiTableRow-root:nth-of-type(odd), & .MuiTableRow-root:nth-of-type(odd):hover':
                                    {
                                        backgroundColor: 'action.selected',
                                    },
                            }}
                        >
                            {listItems.map((listItem, lIndex) => (
                                <TableRow key={lIndex}>
                                    <TableCell component="th" scope="row">
                                        {this.props.kedo
                                            .env()
                                            .translateItem(
                                                listItem,
                                                'displayitem'
                                            )}
                                    </TableCell>
                                    <TableCell>
                                        {this.props.getValue(
                                            listItem,
                                            dossierData,
                                            dossier
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </CardContent>

                {this.props.block.settings.inline_edit && (
                    <CardActions>
                        <DossierModalEditButton
                            dossierId={dossier.id}
                            kedo={this.props.kedo}
                        />
                    </CardActions>
                )}
            </Card>
        )
    }

    render() {
        return (
            <Grid container spacing={2}>
                {this.props.data.dossiers.map((dossier) => {
                    const dossierData = this.props.data.contents.filter(
                        (dataItem) => dataItem.id === dossier.id
                    )
                    return (
                        <Grid size={{ xs: 12, sm: 6, md: 4 }} key={dossier.id}>
                            {this.renderContentCard(
                                dossierData,
                                dossier,
                                this.props.listItems
                            )}
                        </Grid>
                    )
                })}
            </Grid>
        )
    }
}
